import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Message } from '@models/message';

/**
 * service to show success or error messages after user interaktion
 *
 * this service use material snackbar as component
 * @see https://material.angular.io/components/snack-bar/overview
 * @implements {Function} success - shows success message
 * @implements {Function} error - shows error message
 * @param {object} msg
 */
@Injectable( {
    providedIn: 'root'
} )
export class MessageService {
    #snackBar = inject( MatSnackBar );

    /**
     * show success message
     * message disappears automatically after 3 seconds
     * @param {string} msg - text of message
     * @property {string} panelClass - default is 'snack-success'
     */
    success( msg: Message ) {
        const snackBarRef = this.#snackBar.open( msg.text, undefined, {
            duration: 7000,
            panelClass: [ 'snackbar--success' ]
        } );
        return snackBarRef;
    }

    /**
     * show error message
     * message disappears automatically after 3 seconds
     * @param {string} err - text of error message
     * @property {string} panelClass - default is 'snack-error'
     */
    error( err: Message ) {
        const snackBarRef = this.#snackBar.open( err.text, undefined, {
            duration: 7000,
            panelClass: [ 'snackbar--error' ]
        } );
        return snackBarRef;
    }

    /**
     * show message with action
     * @param {string} msg - text of action message
     * @property {number} duration - default is 1 minute.
     * @property {string} panelClass - default is 'snack-action'
     */
    action( msg: Message ) {
        const snackBarRef = this.#snackBar.open( msg.text, msg.action, {
            duration: msg.duration || undefined,
            panelClass: [ 'snackbar--action' ]
        } );
        return snackBarRef;
    }
}
